"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var SectionImages = function SectionImagesComponent(_ref) {
  var sliceData = _ref.sliceData;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__image-wrapper"
  }, sliceData.items.map(function (_ref2) {
    var image_asset = _ref2.image_asset;
    return /*#__PURE__*/_react["default"].createElement("img", {
      className: "content-page__image",
      src: image_asset.url,
      alt: image_asset.name,
      key: "picture of ".concat(image_asset.name)
    });
  }));
};

SectionImages.propTypes = {
  sliceData: _propTypes["default"].shape({
    items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      image_asset: _propTypes["default"].shape({
        url: _propTypes["default"].string.isRequired,
        name: _propTypes["default"].string.isRequired
      }).isRequired
    })).isRequired
  }).isRequired
};
var _default = SectionImages;
exports["default"] = _default;